




























import { auth } from "@/scripts/firebase";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class Header extends Vue {
  isActive = false;
  get hasUser(): boolean {
    return !!this.$store.state.user;
  }
  handleSignOut() {
    auth.signOut();
    this.isActive = false;
  }
}
